import { UrlConfig } from '@shared/config/url.config';

export class MesFinancementsConfig {
  private static listDossiers: string = UrlConfig.urlDossier + 'dossiers/search';
  private static listDossiersExport: string = UrlConfig.urlDossier + 'dossiers/export';
  private static listStagiairesExport: string = UrlConfig.urlDossier + 'stagiaires/export';

  public static get listeDossiers(): string {
    return MesFinancementsConfig.listDossiers;
  }

  public static get listeDossiersExport(): string {
    return MesFinancementsConfig.listDossiersExport;
  }

  public static get listeStagiairesExport(): string {
    return MesFinancementsConfig.listStagiairesExport;
  }
}
